'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _aureliaFramework = require('aurelia-framework');

var _coreEs = require('@mojility/core-es6');

var _coach_http_client_factory = require('../util/coach_http_client_factory');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountGateway = (_dec = (0, _aureliaFramework.inject)(_coach_http_client_factory.CoachHttpClientFactory), _dec(_class = function (_HttpGateway) {
    _inherits(AccountGateway, _HttpGateway);

    function AccountGateway(coachHttpClientFactory) {
        _classCallCheck(this, AccountGateway);

        return _possibleConstructorReturn(this, (AccountGateway.__proto__ || Object.getPrototypeOf(AccountGateway)).call(this, coachHttpClientFactory));
    }

    _createClass(AccountGateway, [{
        key: 'authenticate',
        value: function authenticate(email, password) {
            var eula = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return this.post('authenticate', { email: email, password: password, eula: eula }, {
                401: function _(response) {
                    return response.json().then(function (data) {
                        if (data.status == 'eula') {
                            return _coreEs.Failure.reject(_coreEs.Severity.OK, 'Please accept the updated End User License Agreement');
                        } else {
                            return _coreEs.Failure.reject(_coreEs.Severity.WARNING, 'Invalid email or password.');
                        }
                    });
                }
            });
        }
    }, {
        key: 'requestAccountCreation',
        value: function requestAccountCreation(email) {
            return this.post('account/creation', {
                email: email
            }, {
                400: function _() {
                    return _coreEs.Failure.reject(_coreEs.Severity.WARNING, 'That email address is already associated with an account.');
                }
            });
        }
    }, {
        key: 'checkCreationToken',
        value: function checkCreationToken(token) {
            return this.get('account/creation/' + token, {
                404: function _() {
                    return _coreEs.Failure.reject(_coreEs.Severity.WARNING, 'Unable to validate your token.');
                }
            });
        }
    }, {
        key: 'completeAccountCreation',
        value: function completeAccountCreation(data) {
            return this.put('account/creation/' + data.token, {
                name: data.name,
                phone: data.phone,
                password: data.password
            });
        }
    }, {
        key: 'getInvitation',
        value: function getInvitation(token) {
            return this.get('account/invitation/' + token, {
                400: function _() {
                    return _coreEs.Failure.reject(_coreEs.Severity.WARNING, 'An account has already been created for this invitation. Please log in to accept or decline this invitation.');
                },
                404: function _() {
                    return _coreEs.Failure.reject(_coreEs.Severity.ERROR, 'This invitation does not exist');
                }
            });
        }
    }, {
        key: 'createAccountWithInvitation',
        value: function createAccountWithInvitation(token, data) {
            data.password_confirmation = data.password;

            return this.post('account/invitation/' + token, data, {
                400: function _() {
                    return _coreEs.Failure.reject(_coreEs.Severity.WARNING, 'Something is wrong with your information');
                },
                404: function _() {
                    return _coreEs.Failure.reject(_coreEs.Severity.ERROR, 'This invitation does not exist');
                }
            });
        }
    }, {
        key: 'requestPasswordReset',
        value: function requestPasswordReset(email) {
            return this.post('account/password/request_reset', { email: email }, {
                404: function _() {
                    return _coreEs.Failure.reject(_coreEs.Severity.WARNING, 'That email address is not registered here.');
                }
            });
        }
    }, {
        key: 'checkResetToken',
        value: function checkResetToken(token) {
            return this.get('account/reset_password/' + token, {
                404: function _() {
                    return _coreEs.Failure.reject(_coreEs.Severity.WARNING, 'Provided secret token is not valid.');
                }
            });
        }
    }, {
        key: 'resetPassword',
        value: function resetPassword(token, password) {
            return this.put('account/reset_password/' + token, { password: password }, {
                404: function _() {
                    return _coreEs.Failure.reject(_coreEs.Severity.WARNING, 'Unable to reset password. Secret token may not be valid.');
                }
            });
        }
    }, {
        key: 'updateDetails',
        value: function updateDetails(name, phone, secretKey) {
            return this.authenticatedPut(secretKey, 'coach/details', {
                details: {
                    name: name,
                    phone: phone
                }
            });
        }
    }]);

    return AccountGateway;
}(_coreEs.HttpGateway)) || _class);
exports.default = AccountGateway;